import React, { useRef } from 'react';
import { useEffect } from 'react';
import styled from 'styled-components';

import moon from '../assets/images/moonlight.svg';
import star from '../assets/images/star.svg';

function Layoutsvg() {

  const moonlight = useRef();
  const stars = useRef();

  useEffect(()=>{ //it need to be in useEffect so that it runs only when the dom has mounted.
    window.addEventListener('mousemove', (e)=>{
      
      let lightXaxis = (window.innerWidth-e.pageX)/40;//the less we divide the more they move
      let lightYaxis = (window.innerHeight-e.pageY)/8;

      // console.log(lightXaxis);
  
      let starsXaxis = (window.innerWidth-e.pageX)/80;
      let starsYaxis = (window.innerHeight-e.pageY)/50;
  
      if(moonlight.current){
        moonlight.current.style.transform = `translateX(${lightXaxis}px) translateY(${lightYaxis}px)`;
        stars.current.style.transform = `translateX(${starsXaxis}px) translateY(${starsYaxis}px)`;
      }
  
    });
  }, [])



  return (
    <Container className='layout-svg-container' >
      <img className='moonlight parallax ' ref={moonlight} src={moon} alt="" />
      <img className='star parallax ' ref={stars} src={star} alt="" />
    </Container>
  )
}

const Container = styled.div`
    position: absolute;
    overflow: hidden;
    width: 100vw;
    height: 100vh;

    .moonlight{
        position: absolute;
        top: -50%;
        right: -18%;
    }
    .star{
        position: absolute;
        top: -50%;
        right: -18%;
        /* right: 17px; */
    }

    @media only screen and (max-width: 1080px){
      .moonlight{
        position: absolute;
        right: -50%;
      }
      .star{
          position: absolute;
          right: -50%;
          /* right: 17px; */
      }
    }

    @media only screen and (max-width: 500px){
      height: 100vh;
      width: 100vw;
      top: 30%;
      left: 50%;
      transform: translate(-50%, -50%);
      overflow: hidden;

      .moonlight, .stars{
        height: 150%;
        width: 150%;
        top: -27%;
        left: -20%;
      }

    }

`;

export default Layoutsvg;